module.exports = __webpack_public_path__ + "img/mahaheng-logo.ec61c1d8.png";